import { observable } from 'mobx';

class ToolTipStore {
  @observable accessor toolTipVisible;

  constructor() {
    this.showToolTip = this.showToolTip.bind(this);
    this.hideToolTip = this.hideToolTip.bind(this);
    this.toggleToolTip = this.toggleToolTip.bind(this);
  }

  showToolTip() {
    this.toolTipVisible = true;
  }

  toggleToolTip() {
    this.toolTipVisible = !this.toolTipVisible;
  }

  hideToolTip() {
    this.toolTipVisible = false;
  }
}

const ToolTipData = new ToolTipStore();

export default ToolTipData;
